import * as Yup from "yup";

export interface SelectDetailsFormValues {
    gender: string;
    sexualOrientation: string;
    lookingFor: string[];
    status: string;
    showMe: string[];
}

export const selectdetailsValidationSchema = Yup.object({
    gender: Yup.string().required("Gender is required"),
    sexualOrientation: Yup.string().required("Sexual orientation is required"),
    lookingFor: Yup.array()
        .of(Yup.string())
        .min(1, "Select at least one")
        .required("Looking for is required"),
    status: Yup.string().required("Status is required"),
    showMe: Yup.array()
        .of(Yup.string())
        .min(1, "Select at least one")
        .required("Show Me is required"),
});
